import { field, json, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import { noopSanitizeJSON } from "../utils";

export default class Staff extends BaseModel {
  static table = "staffs";
  @text("full_name") fullName: string;
  @text("initials") initials: string;
  @field("enabled") enabled: boolean;
  @text("username") username: string;
  @text("user_id") userId: string;
  @json("terminal_ids", noopSanitizeJSON) terminalIds: string[];
  @text("email_address") emailAddress: string;
  @field("has_user_account") hasUserAccount: boolean;
}
